import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _FloatButton from './float-button.vue';

const FloatButton = Object.assign(_FloatButton, {
  install: (app: App, options?: ArcoOptions) => {
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _FloatButton.name, _FloatButton);
  },
});

export type FloatButtonInstance = InstanceType<typeof _FloatButton>;

export default FloatButton;
